import { observable } from 'mobx';

import { BaseFormModel } from '../../BaseForm';

class MenuDesignForm extends BaseFormModel {
  @observable
  file: File | null;

  @observable
  editedFile: File;
}

export default MenuDesignForm;
